import { mapSeriesWithDatetime } from './shared';

export default {
  buildFields() {
    return [
      { key: 'datetime', label: 'Date Time', class: 'text-center' },
      { key: 'duration', label: 'Duration', class: 'text-center' },
    ];
  },
  buildLogs(seriesData) {
    return mapSeriesWithDatetime(seriesData);
  },
  buildSummary(seriesData, { dateParam }) {
    const totalDuration = seriesData.reduce((sum, serie) => sum + serie.duration, 0);
    const { start, end } = dateParam.range;
    const selectionDuration = (end - start) / 1000;
    return { totalDuration, selectionDuration };
  },
};
